import axiosInstance from '../../helpers/axiosInstance'

export default function calcularService (inputs) {
    return axiosInstance.post('calculo', inputs)
        .then(response => response.data)
        .catch(error => {
          throw error;
        });
}